import React from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type billingDetailsForm_Billing_CustomerDetailsFragment$key } from "@relay/billingDetailsForm_Billing_CustomerDetailsFragment.graphql";
import { BILLING_DETAILS_FRAGMENT } from "./billing-details-form.graphql";
import { type BillingDetailsFormProps } from "./billing-details-form.interface";
import { BusinessBillingDetailsForm } from "../business-billing-details-form/business-billing-details-form.component";
import { PrivateBillingDetailsForm } from "../private-billing-details-form/private-billing-details-form.component";

export const BillingDetailsForm = ({ billingDetailsFragmentRef }: BillingDetailsFormProps) => {
	const { t } = useTranslation("common");
	const billingDetails = useFragment<billingDetailsForm_Billing_CustomerDetailsFragment$key>(
		BILLING_DETAILS_FRAGMENT,
		billingDetailsFragmentRef,
	);

	switch (billingDetails.data.kind) {
		case "Private":
			return <PrivateBillingDetailsForm privateBillingDetailsFragmentRef={billingDetails} />;
		case "Business":
			return (
				<BusinessBillingDetailsForm businessBillingDetailsFragmentRef={billingDetails} />
			);
		default:
			return <div>{t("order.noData")}</div>;
	}
};
